import { render, staticRenderFns } from "./ChunkUploadPackage.vue?vue&type=template&id=b975afaa"
import script from "./ChunkUploadPackage.vue?vue&type=script&lang=js"
export * from "./ChunkUploadPackage.vue?vue&type=script&lang=js"
import style0 from "./ChunkUploadPackage.vue?vue&type=style&index=0&id=b975afaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports